/**
* @license Apache-2.0
*
* Copyright (c) 2024 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Determine the index offset which specifies the location of the first indexed value in a strided array.
*
* @module @stdlib/strided-base-stride2offset
*
* @example
* var stride2offset = require( '@stdlib/strided-base-stride2offset' );
*
* var offset = stride2offset( 10, -10 );
* // returns 90
*/

// MODULES //

var stride2offset = require( './main.js' );


// EXPORTS //

module.exports = stride2offset;
